import { ImageStrapiProps } from '@/decodo/components/atoms/Image/ImageStrapi';
import { ProductComparisonItemProps } from '../../../ProductComparisonTable';
import { ProductDropdown } from './ProductDropdown';

interface ComparisonDropdownGroupProps {
  index: number;
  selectedItems: (string | null)[];
  productComparisonItems: ProductComparisonItemProps[];
  onSelectChange: (index: number, value: string | null) => void;
  onRemove: (index: number) => void;
}

export function ComparisonDropdownGroup({
  index,
  selectedItems,
  productComparisonItems,
  onSelectChange,
}: ComparisonDropdownGroupProps) {
  // Prevent rendering third dropdown if first two aren't selected
  if (index > selectedItems.filter(Boolean).length + 1) {
    return <div key={`select-${index}`} />;
  }

  const isDisabled = index > selectedItems.filter(Boolean).length;
  const selectedItem = productComparisonItems.find(
    (item) => item.itemTitle === selectedItems[index]
  );

  const selectedOption = selectedItem
    ? {
        value: selectedItem.itemTitle,
        label: selectedItem.productType.productTitle,
        type: selectedItem.productType.productTypeName,
        icon: selectedItem.productType.productIcon,
      }
    : null;

  const options = productComparisonItems
    .filter((item) => {
      return (
        item.itemTitle &&
        (!selectedItems.includes(item.itemTitle) ||
          item.itemTitle === selectedItems[index])
      );
    })
    .map((item) => ({
      value: item.itemTitle as string,
      label: item.productType.productTitle as string,
      type: item.productType.productTypeName as string,
      icon: item.productType.productIcon as ImageStrapiProps,
    }));

  return (
    <div key={`select-${index}`} className='flex items-center gap-2'>
      <div className='bg-gray-25 mb-5 mt-8 flex w-full flex-grow flex-col md:my-0'>
        <ProductDropdown
          name={`product-dropdown-${index}`}
          options={options}
          value={selectedOption}
          isDisabled={isDisabled}
          onOptionChange={(option) =>
            onSelectChange(index, option?.value || null)
          }
        />
      </div>
    </div>
  );
}
